const faqs = [
  {
    q: '51吃瓜网址是什么？',
    a: '51吃瓜网址是一个聚合全网热门娱乐八卦、明星动态、剧综吐槽等内容的一站式导航平台。我们整合51吃瓜网址新入口、51吃瓜官网全网最新等官方直达通道，每日更新防走失域名，确保用户在任何情况下都能稳定访问最新吃瓜资讯。',
  },
  {
    q: '为什么需要防走失域名？',
    a: '由于网络环境的变化，部分域名可能会出现访问不稳定的情况。51吃瓜网站入口提供多个备用域名与防走失地址，当主域名暂时无法访问时，您可以通过备用入口一键直达，确保吃瓜不迷路。建议同时收藏多个入口以备不时之需。',
  },
  {
    q: '如何收藏51吃瓜网址？',
    a: '建议您将本页添加到浏览器书签，或关注我们的最新地址发布渠道。在电脑端按 Ctrl+D（Mac：Cmd+D）即可快速收藏；手机端使用浏览器菜单中的"添加到主屏幕"或"收藏"功能。本站会持续维护并更新所有可用入口。',
  },
  {
    q: '网站内容来源于哪里？',
    a: '51吃瓜网址作为信息导航与聚合平台，内容均来源于网络公开信息与用户分享。我们通过智能算法与人工筛选，从海量信息中挑出最受关注的热门话题，按主题分类整理后呈现给用户，帮助大家高效获取感兴趣的吃瓜内容。',
  },
  {
    q: '手机端如何使用51吃瓜网址？',
    a: '51吃瓜网址已全面适配移动端，手机浏览器直接访问即可获得流畅的浏览体验。不需要下载任何APP，页面会自动适配您的手机屏幕尺寸。移动端同样支持防走失域名自动跳转，随时随地畅享最新吃瓜资讯。',
  },
  {
    q: '51吃瓜网址是否收费？',
    a: '51吃瓜网址完全免费使用，不收取任何费用，也无需注册登录。我们致力于为用户提供便捷、高效的吃瓜导航服务。请注意，本站为纯导航平台，不存储任何用户个人数据，请您放心使用。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="w-full py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-3">常见问答</h2>
          <p className="text-foreground-600 text-sm md:text-base">关于51吃瓜网址，你想知道的都在这里</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 max-w-4xl mx-auto">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 border border-background-200/60 rounded-xl p-5 md:p-6 hover:border-primary-200/50 transition-colors duration-200"
            >
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 mb-2 flex items-start gap-2">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">
                  <i className="ri-question-answer-line"></i>
                </span>
                {faq.q}
              </h3>
              <p className="text-foreground-600 text-xs md:text-sm leading-relaxed">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}